import {CommonMessages} from '../common.messages';

export const PanelSettingsGroupsEditMessages = {
    GetClientFailed: {
        key: 'GetClientFailed',
        message: 'Error while communication with the server. Unable to get trading group information.'
    },
    ClientNotFound: {
        key: 'ClientNotFound',
        message: 'Unable to find information about the search trading group.'
    },
    GetIndividualFailed: {
        key: 'GetIndividualFailed',
        message: 'Error while communication with the server. Unable to get client individual details.'
    },
    IndividualNotFound: {
        key: 'IndividualNotFound',
        message: 'Error while communication with the server. Unable to find client individual details.'
    },
    GetCompanyFailed: {
        key: 'GetCompanyFailed',
        message: 'Error while communication with the server. Unable to get client company details.'
    },
    CompanyNotFound: {
        key: 'CompanyNotFound',
        message: 'Error while communication with the server. Unable to find client company details.'
    },
    ...CommonMessages
};
